<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>变更统计</span>
                        <span>变更事件统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156946"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData"
                                show-summary>
                                <el-table-column width="80" prop="name" label="人员名称"></el-table-column>
                                <el-table-column prop="changeCount" label="变更请求数量" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="solutionCount" label="制定方案成数" sortable :sort-orders="sortList"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:'',
                options:{
                    tooltip : {},
                    legend: {},
                    dataset:{},
                    dataZoom:[
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'inside',
                            yAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            yAxisIndex: 0,
                        },
                    ],
                    xAxis: [{type: 'category',}],
                    yAxis: [{}],
                    series: [
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                    ]
                },
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                let sendTableData = JSON.parse(JSON.stringify(this.tableData));
                let changeCount = 0;
                let solutionCount = 0;
                this.tableData.forEach(res=>{
                    changeCount += Number(res.changeCount);
                    solutionCount += Number(res.solutionCount);
                })
                sendTableData.push({name:'合计',changeCount,solutionCount});
                let header = [];
                let filterVal = [];
                header = ['人员名称', '变更请求数量', '制定方案成数'];
                filterVal = ['name', 'changeCount', 'solutionCount'];
                const list = sendTableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel({header,data,filename:`变更事件统计${this.value[0]}—${this.value[1]}`});
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                    group:'changeManager',
                }
                services.getlist(params).then(res=>{
                    // res.graphData[0] = ["product","变更请求数量", "制定方案数量"];
                    this.getMes = res;
                    this.tableData = res.tableData;
                    this.getEcharts();
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                this.options.dataset.source = this.getMes.graphData;
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
